import { orderedListSlide } from './SLSprint00'

import { list20000Sprint07 } from '../ActivityLists/AL20000Sprint07'
import { list20000Sprint08 } from '../ActivityLists/AL20000Sprint08'

import { xyz_8_1of1_PAaA, xyz_8_ClassProductPresentations } from './SL00000Sprint00TTR'

// Introduction to Computer Science (ICS) sprint 8 global values.
const sprint = 8
const activityList = () => { return list20000Sprint08(sprint) }
const activityListPrevious = () => { return list20000Sprint07(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

/*
			<li>An overview of your {finalProjectProposalLink()} including which features are completed.</li>
			<li>A demonstration of your product focusing on the <em>greater in complexity</em> features delivered.</li>
			<li>A review of the code highlighting the <em>greater in complexity</em> features and explaining your 
				implementation.</li>
			<li>A description what you would do next if you had more time to work on the project.</li>
*/


const ics_8_1of1 = () => {
	const productPresentation = () => {
		return orderedListSlide(
			'Class Product Presentations', 
			`For your product presentation please:`, [
			'Briefly review your Class Project Proposal including which features are completed',
			'Demonstrate product features in action, highlighting the **greater in complexity** features',
			'Review the source code of the **greater in complexity** features and explain your implementation',
			'Describe what you would do next if you had more time to work on the project' ])
	} 
	return xyz_8_ClassProductPresentations(xyz_8_1of1_PAaA, null, sprintAndActivityLists, productPresentation) 
}

export const ics_8_slidedeckTTR = [ ics_8_1of1 ]
